import { Star, Quote } from "lucide-react";
import Reveal from "@/components/Reveal";

const REVIEWS = [
  {
    id: "review-card-1",
    name: "Margaret H.",
    area: "Westfield",
    text: "Our Sub-Zero was warming up on a Friday. Thortek diagnosed a failing evaporator fan by phone, had the OEM part Saturday morning, and calibrated the whole unit before lunch. Flawless.",
    appliance: "Sub-Zero Refrigerator",
  },
  {
    id: "review-card-2",
    name: "Daniel R.",
    area: "Summit",
    text: "Three other companies told us to replace our Wolf range. Thortek rebuilt the ignition system for a fifth of the cost. Two years on the Shield Plan now — zero issues since.",
    appliance: "Wolf Dual-Fuel Range",
  },
  {
    id: "review-card-3",
    name: "Priya S.",
    area: "Cranford",
    text: "On time, shoe covers, a printed diagnostic report, and a Miele dishwasher that runs quieter than the day it was installed. This is how service should feel.",
    appliance: "Miele Dishwasher",
  },
];

export default function Reviews() {
  return (
    <section id="reviews" data-testid="reviews-section" className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <Reveal className="flex flex-wrap items-end justify-between gap-8">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#E06A26] mb-5">Client reviews</p>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight max-w-xl">
              Trusted in the finest homes across New Jersey.
            </h2>
          </div>
          <div data-testid="reviews-rating-summary" className="flex items-center gap-4">
            <span className="font-display text-5xl font-extrabold text-[#E06A26]">4.9</span>
            <div>
              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-[#E06A26] text-[#E06A26]" />
                ))}
              </div>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#606D7A] mt-1.5">240+ verified reviews</p>
            </div>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mt-14">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.id} delay={i * 0.12}>
              <figure
                data-testid={r.id}
                className="rounded-2xl border border-white/10 bg-[#171B20]/90 p-8 h-full flex flex-col transition-all duration-500 hover:border-[#E06A26]/35 hover:-translate-y-1.5"
              >
                <Quote className="w-6 h-6 text-[#E06A26]/60 mb-6" strokeWidth={1.5} />
                <blockquote className="text-sm sm:text-base text-[#F4F2EE]/85 leading-relaxed flex-1">"{r.text}"</blockquote>
                <figcaption className="mt-8 pt-6 border-t border-white/10">
                  <p className="font-semibold text-sm">{r.name} <span className="text-[#606D7A] font-normal">· {r.area}</span></p>
                  <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#E06A26] mt-1.5">{r.appliance}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
